import React from 'react';
import { Helmet } from 'react-helmet-async';
import './MenuPage.css';
import MenuCard from './MenuCard';
import { menuData, categories } from './menuData';

const MenuPage = () => {

  return (
    <div className="menu-page">
      <Helmet>
        <title>Menü – WakaGyros | Görög tálak, piták, boxok</title>
        <meta name="description" content="Válaszd ki kedvenc görög fogásod: tálak, piták, boxok, mártogatósok és desszertek – friss alapanyagokkal." />
        <link rel="canonical" href="https://www.wakagyros.hu/menu" />
        <meta property="og:title" content="Menü – WakaGyros | Görög tálak, piták, boxok" />
        <meta property="og:description" content="Válaszd ki kedvenc görög fogásod: tálak, piták, boxok, mártogatósok és desszertek – friss alapanyagokkal." />
        <meta property="og:url" content="https://www.wakagyros.hu/menu" />
      </Helmet>

      {/* Menu Sections */}
      {categories.map((category) => {
        const products = menuData[category.id] || [];
        
        return (
          <section 
            key={category.id}
            id={category.id}
            className="menu-section scroll-mt-[88px]"
          >
            <div className="container">
              <div className="section-header">
                <h2>{category.name}</h2>
              </div>
              
              <div className="product-grid">
                {products.map((product) => (
                  <MenuCard
                    key={product.id}
                    product={product}
                    onAddToCart={(product) => {
                      console.log('Added to cart:', product.name);
                      // Add to cart logic here
                    }}
                  />
                ))}
              </div>
              
            </div>
          </section>
        );
      })}
    </div>
  );
};

export default MenuPage;
